var render, staticRenderFns
import script from "./LinkJumpPage.vue?vue&type=script&lang=js&"
export * from "./LinkJumpPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/adlandingpage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2acec89e')) {
      api.createRecord('2acec89e', component.options)
    } else {
      api.reload('2acec89e', component.options)
    }
    
  }
}
component.options.__file = "src/views/LinkJumpPage.vue"
export default component.exports